import { useParams } from 'react-router-dom'
import { useState } from 'react'
import { useAutoStatsBases, useMountpointInfo } from 'api'
import { MountpointInfoForm } from './MountpointInfoForm'
// import { useMap, MapContextProps } from 'MapProvider'
import Card from 'common/Card'
import { strings } from 'strings'

const BASES_LOOKBACK_MS = 24 * 60 * 60 * 1000

export function MountpointInfo() {
  const { mid } = useParams<any>()
  const { mountpointInfo, loading, error } = useMountpointInfo(mid)

  const [basesRange] = useState(() => ({
    from: new Date(Date.now() - BASES_LOOKBACK_MS).toISOString(),
    to: new Date().toISOString(),
  }))
  const { bases } = useAutoStatsBases(basesRange.from, basesRange.to)

  // const { map } = useMap() as MapContextProps

  let content

  if (loading) content = <div>Loading</div>
  else if (error) content = <div>{error.message}</div>
  else if (mountpointInfo) {
    const owner = bases?.find((b) => b.mountpoint === mountpointInfo.name)
    content = (
      <MountpointInfoForm
        mountpointInfo={mountpointInfo}
        ownerDisplayName={owner?.ownerDisplayName ?? ''}
        ownerPhoneNumber={owner?.ownerPhoneNumber ?? ''}
      />
    )
    // map?.flyTo({
    //   center: [mountpointInfo.longitude, mountpointInfo.latitude],
    //   essential: true,
    //   zoom: 15,
    // })
  }

  return (
    <Card title={strings.stationSettigns} style={{ overflow: 'auto', paddingBottom: 0 }}>
      {content}
    </Card>
  )
}
